module.exports = __webpack_public_path__ + "img/10.7.Chla.6065272a.png";